const _excluded = ["dims", "currentPageIndex", "scale", "pageIndex", "rotate", "children", "onView"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { InView } from 'react-intersection-observer';
import clsx from 'clsx';
import { ViewPdfDataRangeLoadingPagePlaceholder, ViewPdfPagePlaceholder } from "./view-pdf-page-placeholder.component";
import { useArchiveLayoutDimensions } from "../../../base/layout";
import { useIoConfig } from "../../../base/page";
import { ViewPdfPageBase } from "./view-pdf-page-base.component";

// TODO make scroll pagination with IntersectionObserver generic (use it in tiff too at least)

export const ViewPdfPage = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      dims,
      currentPageIndex,
      scale,
      pageIndex,
      rotate,
      children,
      onView
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    layoutDim
  } = useArchiveLayoutDimensions();
  const {
    ioConfig,
    changePageThreshold
  } = useIoConfig(layoutDim, scale, rotate, dims);

  // const { ref: viewRef, inView, entry } = useInView({threshold: [0,0.5]})

  // TODO mirar si el hecho de renderizar y desrenderizar afecta mucho (y ver sobre todo cuando cambia escala
  // y estan todas renderizadas etc)
  // TODO que en el padre solo cambie el hijo no cuando cambie el page Index etc (lo que mas penaliza
  // es el renderizado de cambio de pagina)
  // TODO PARECE QUE EFECTIVAMENTE SE MANTIENE LO YA RENDERIZADO
  const alreadyMounted = React.useRef(false);

  // const setRefs = React.useCallback(
  //   node => {
  //     if (typeof ref === 'function') ref(node)
  //     else if (ref) ref.current = node
  //     viewRef(node)
  //   },
  //   []
  // )

  // React.useEffect(() => {
  //   if (onScrollPageIndexChange && entry) {
  //     if (entry.intersectionRatio > changePageThreshold) {
  //       onScrollPageIndexChange(pageIndex)
  //     }
  //   }
  // }, [entry])

  return /*#__PURE__*/React.createElement("div", {
    className: clsx({
      'view-pdf-page': Boolean(dims),
      'mx-auto': !Boolean(dims)
    }),
    ref: ref
  }, dims ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InView, _extends({}, ioConfig, {
    onChange: (inView, entry) => {
      if (inView && onView && entry) {
        if (entry.intersectionRatio > changePageThreshold) {
          onView(pageIndex);
        }
      }
      if (inView) alreadyMounted.current = true;
    }
  }), ({
    inView,
    ref: inViewRef,
    entry
  }) => /*#__PURE__*/React.createElement("div", {
    ref: inViewRef
  }, currentPageIndex === pageIndex - 1 || inView || alreadyMounted.current ? /*#__PURE__*/React.createElement(ViewPdfPageBase, _extends({
    scale: scale,
    rotate: rotate,
    pageIndex: pageIndex,
    children: children
  }, rest)) : /*#__PURE__*/React.createElement(ViewPdfPagePlaceholder, {
    scale: scale,
    rotate: rotate,
    dims: dims
  })))) : /*#__PURE__*/React.createElement(ViewPdfDataRangeLoadingPagePlaceholder, null));
});